import 'bootstrap'
import device from './device'
$('body').scrollspy({ target: '#header-nav' })

let $body = $('body')
let $skWave = $('.sk-wave')

let mobileOS = device.getMobileOperatingSystem()
let className = (mobileOS === "Windows Phone" || mobileOS === "Android") ? 'static-page' : ''
$body.addClass(className)

setTimeout(() => {
  $body.removeClass('page-loading')
  setTimeout(() => {
    $body.addClass('page-loaded')
    $skWave.remove()
  }, 1000)
}, 1000)





/** WEBPACK FOOTER **
 ** assets/javascripts/global.js
 **/